import { render } from "./DangerModal.vue?vue&type=template&id=65f724f7&scoped=true"
import script from "./DangerModal.vue?vue&type=script&lang=js"
export * from "./DangerModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65f724f7"]])

export default __exports__